import NodeStartProperty from "../components/molecules/node-start-propety";
import NodeReadDbProperty from "../components/molecules/node-read-bd-property";
import NodeIfProperty from "../components/molecules/node-if-property";
import NodeInsertProperty from "../components/molecules/node-insert-property";
import NodeUpdateProperty from "../components/molecules/node-update-property";
import NodeDeleteProperty from "../components/molecules/node-delete-property";
import NodeThrowErrorProperty from "../components/molecules/node-throw-error-property";
import NodeReturnProperty from "../components/molecules/node-return-property";
import NodeFunctionProperty from "../components/molecules/node-function-property";
import { dbType } from "./mrTypes";
import { t } from "../utils/utils";

export const START = "uStart.types.start";
export const IF = "uStart.types.if";
export const DB_FIND = "uStart.types.db.operation.find";
export const DB_INSERT = "uStart.types.db.operation.insert";
export const DB_UPDATE = "uStart.types.db.operation.update";
export const DB_DELETE = "uStart.types.db.operation.delete";
export const FN_LENGTH = "uStart.types.fn.operation.length";
export const FN_MOD = "uStart.types.fn.operation.mod";
export const ERROR = "uStart.types.throw.error";
export const RETURN = "uStart.types.return";
export const FUNC = "uStart.types.function";
export const FUNCTION_TYPES = [
  { name: "Length", type: FN_LENGTH, out: "Int", use: ["array", "string"] },
  {
    name: "Modulo",
    type: FN_MOD,
    out: "Int",
    use: ["int"], //los tipos en que se puede usar esta funcion
    form: {
      mod: {
        type: "number",
        tooltip: t("funcionModuloTooltip"),
        title: t("funcionModuloTitulo"),
      },
    }, // formulario dinamico
  },
];
export const NODE_NAMES = {
  [START]: {
    name: "nodoInicio",
    title: "nodoInicioTitulo",
    description: "nodoInicioDescripcion",
  },
  [IF]: {
    name: "nodoCondicion",
    title: "nodoCondicionTitulo",
    description: "nodoCondicionDescripcion",
  },
  [DB_FIND]: {
    name: "nodoBuscar",
    title: "nodoBuscarTitulo",
    description: "nodoBuscarDescripcion",
  },
  [DB_INSERT]: {
    name: "nodoAgregar",
    title: "nodoAgregarTitulo",
    description: "nodoAgregarDescripcion",
  },
  [DB_UPDATE]: {
    name: "nodoActualizar",
    title: "nodoActualizarTitulo",
    description: "nodoActualizarDescripcion",
  },
  [DB_DELETE]: {
    name: "nodoEliminar",
    title: "nodoEliminarTitulo",
    description: "nodoEliminarDescripcion",
  },
  [FN_LENGTH]: {
    name: "",
    title: "Nodo: obtener tamaño de un listado",
    description:
      "Este nodo te permite obtener el número de registros de un listado, este número quedará guardado por si lo necesitas mas adelante",
  },
  [FN_MOD]: {
    name: "",
    title: "Nodo: obtener el módulo de un número",
    description:
      "Este nodo te permite obtener el módulo de un número, este valor quedará almacenado por si lo necesitas mas adelante dentro de este mismo flujo",
  },
  [ERROR]: {
    name: "nodoError",
    title: "nodoErrorTitulo",
    description: "nodoErrorDescripcion",
  },
  [RETURN]: {
    name: "nodoRetorno",
    title: "nodoRetornoTitulo",
    description: "nodoRetornoDescripcion",
  },
  [dbType]: {
    name: "nodoModelo",
    title: "nodoModeloTitulo",
    description: "nodoModeloDescripcion",
  },
  [FUNC]: {
    name: "nodoFuncion",
    title: "nodoFuncionTitulo",
    description: "nodoFuncionDescripcion",
  },
};

export const nodeTypes = [
  {
    type: IF,
    propertyComponent: NodeIfProperty,
    properties: {
      style: {
        height: 0,
        width: 0,
        icon: "conditional",
      },
      args: {},
      nodeInfo: NODE_NAMES[IF],
    },
    ports: {
      port1: {
        id: "port1",
        type: "left",
        properties: {
          mode: "input",
        },
      },
      port2: {
        id: "port2",
        type: "right",
        properties: {
          mode: "output",
          value: "yes",
          design: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
        },
      },
      port3: {
        id: "port3",
        type: "right",
        properties: {
          mode: "output",
          value: "no",
          design:
            "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
        },
      },
    },
  },
  {
    type: DB_FIND,
    propertyComponent: NodeReadDbProperty,
    properties: {
      style: {
        height: 0,
        width: 0,
        icon: "readDB",
      },
      args: {},
      nodeInfo: NODE_NAMES[DB_FIND],
    },
    exportArgs: {
      query: ["model"],
    },
    ports: {
      port1: {
        id: "port1",
        type: "left",
        properties: {
          mode: "input",
        },
      },
      port2: {
        id: "port2",
        type: "right",
        properties: {
          mode: "output",
        },
      },
    },
  },
  {
    type: DB_INSERT,
    propertyComponent: NodeInsertProperty,
    properties: {
      style: {
        height: 0,
        width: 0,
        icon: "writeBd",
      },
      args: {},
      nodeInfo: NODE_NAMES[DB_INSERT],
    },
    exportArgs: {
      insertAction: ["model"],
    },
    ports: {
      port1: {
        id: "port1",
        type: "left",
        properties: {
          mode: "input",
        },
      },
      port2: {
        id: "port2",
        type: "right",
        properties: {
          mode: "output",
        },
      },
    },
  },
  {
    type: START,
    propertyComponent: NodeStartProperty,
    properties: {
      style: {
        backgroundColor: "#003E60",
        width: 70,
        height: 70,
        borderRadius: "50%",
        icon: "none",
        textStyle: {
          color: "#ffffff",
          fontSize: "13px",
          fontWeight: 600,
        },
      },
      args: {},
    },
    exportArgs: {
      inputData: {},
    },
    ports: {
      port1: {
        id: "port1",
        type: "right",
        properties: {
          mode: "output",
        },
      },
    },
  },
  {
    type: RETURN,
    propertyComponent: NodeReturnProperty,
    properties: {
      style: {
        backgroundColor: "#003E60",
        width: 70,
        height: 70,
        borderRadius: "50%",
        icon: {
          node: "none",
          bar: "rtnNode",
        },
        textStyle: {
          margin: "9px",
          color: "#003E60",
          fontSize: "13px",
          fontWeight: 600,
          borderRadius: "50%",
          width: 60,
          height: 60,
          backgroundColor: "#ffffff",
          marginInnerTextTop: "10px", //propiedad custom para centrar verticalmente el texto de los nodos
        },
      },
      args: {},
    },
    ports: {
      port1: {
        id: "port1",
        type: "left",
        properties: {
          mode: "input",
        },
      },
    },
  },
  {
    type: ERROR,
    propertyComponent: NodeThrowErrorProperty,
    properties: {
      style: {
        height: 0,
        width: 0,
        icon: "error",
      },
      args: {},
      nodeInfo: NODE_NAMES[ERROR],
    },
    ports: {
      port1: {
        id: "port1",
        type: "left",
        properties: {
          mode: "input",
        },
      },
    },
  },
  {
    type: DB_UPDATE,
    propertyComponent: NodeUpdateProperty,
    properties: {
      style: {
        height: 0,
        width: 0,
        icon: "writeBd",
      },
      args: {},
      nodeInfo: NODE_NAMES[DB_UPDATE],
    },
    exportArgs: {
      updateAction: { define: { source: "model", type: "Boolean" } },
    },
    ports: {
      port1: {
        id: "port1",
        type: "left",
        properties: {
          mode: "input",
        },
      },
      port2: {
        id: "port2",
        type: "right",
        properties: {
          mode: "output",
        },
      },
    },
  },
  {
    type: DB_DELETE,
    propertyComponent: NodeDeleteProperty,
    properties: {
      style: {
        height: 0,
        width: 0,
        icon: "deleteBd",
      },
      args: {},
      nodeInfo: NODE_NAMES[DB_DELETE],
    },
    exportArgs: {
      // deleteAction: ["model"]
      deleteAction: { define: { source: "model", type: "Boolean" } },
    },
    ports: {
      port1: {
        id: "port1",
        type: "left",
        properties: {
          mode: "input",
        },
      },
      port2: {
        id: "port2",
        type: "right",
        properties: {
          mode: "output",
        },
      },
    },
  },
  {
    type: FUNC,
    propertyComponent: NodeFunctionProperty,
    properties: {
      style: {
        height: 0,
        width: 0,
        icon: "func",
      },
      args: {},
      nodeInfo: NODE_NAMES[FUNC],
    },
    exportArgs: {
      operatorFunction: [{ data: "type", mach: FUNCTION_TYPES, find: "out" }],
    },
    ports: {
      port1: {
        id: "port1",
        type: "left",
        properties: {
          mode: "input",
        },
      },
      port2: {
        id: "port2",
        type: "right",
        properties: {
          mode: "output",
        },
      },
    },
  },
];
